'use strict';

frontendApp.directive('iioStar', ['HttpService', 'ConfigService', 'NotificationService', function (HttpService, ConfigService, NotificationService) {

  var toggle = function (isFavorite) {
    return (isFavorite ? 'unfavorite' : 'favorite');
  };

  return {
    restrict: 'E',
    template: '<a class="iio-star" ng-click="toggle()">' +
      '<i class="fas fa-star" ng-show="project.favorite" tooltip-animation="true" uib-tooltip="Un Favorite" ></i>' +
      '<i class="far fa-star" ng-hide="project.favorite" tooltip-animation="true" uib-tooltip="Make Favorite" ></i>' +
      '</a>',
    scope: {project: '='},

    link: function (scope, element, attrs) {

      scope.toggle = function () {

        var url = ConfigService.getServerBaseUrl() +
          "/project/" +
          scope.project.id + "/" +
          toggle(scope.project.favorite);

        HttpService.$http({
          method: 'PUT', url: url
        }).success(function (project, status) {
          scope.project.favorite = project.favorite;
        }).error(function (data, status) {
          NotificationService.addError({
            title: 'Error making ' + toggle(scope.project.favorite),
            description: "That's embarrassing, please try again later",
            timeout: 5000
          });
        });

      };
    }
  }
}]);
